import {
    CardCvcElement, CardExpiryElement, CardNumberElement,
    useElements, useStripe
} from "@stripe/react-stripe-js";
import axios from "axios";
import { forwardRef, useImperativeHandle, useState } from "react";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import "./StripePaymentPanel.scss"
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getProviderPlaceOrderV2, paymentUpdateMembershipPage, sendOrderPlace } from "../../../../redux/checkout/actions";
import useLogin from "../../../../custom-hooks/useLogin";
import { SessionKeys } from "../../../../utils/AppUtils";
import moment from "moment";
import { useEffect } from "react";

const StripePaymentPanel = forwardRef((props, ref) => {

    const {
        paymentIntentInfo, setPaymentInProcess,
        setErrorMsg, enableFormField, isMobile, 
        couponCode, isCouponApplied, shouldRedeem
    } = props

    const dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();

    const {isLoggedIn} = useLogin()

    const authBroker = useSelector((state) => state.auth.authBroker);
    const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);

    useEffect(() => {
        
        console.log("auth--",authIframeBroker)
    }, [authIframeBroker]);

    const [cardNumberError, setCardNumberError] = useState("");
    const [cardCVVError, setCardCVVError] = useState("");
    const [cardExpError, setCardExpError] = useState("");

    useImperativeHandle(ref, () => ({
        async handleStripeSubmit(formData, isLoggedIn, type) {
            console.log('Handle Stripe Submit', isLoggedIn, type, paymentIntentInfo)
            if (type === 'subscription' || type === 'coaching') {
                // ONLY FOR GUEST USER
                await updateCustomerData(formData, isLoggedIn, type);
            } else if (type === 'product') {
                let checkoutData = {
                    stripe_data: {
                        payment_intent_client_secret: formData.piClientSecret,
                        payment_intents_token: formData.paymentIntentsToken
                    }
                }
                console.log(paymentIntentInfo);
                // return;
                if (paymentIntentInfo.total && paymentIntentInfo.piClientSecret) {
                    formData.directOrder = false;
                    await stripePayment(checkoutData, formData, isLoggedIn, type)
                } else {
                    formData.directOrder = true;
                    sendProductPaymentResponseToBackend(formData, checkoutData, 'success')
                }
            }
        }
    }))

    const updateCustomerData = async (formData, isLoggedIn, type) => {
        console.log(formData)
        if (!paymentIntentInfo.hasTrialDays || type === 'coaching') {
            let payload = {
                subscription_id: paymentIntentInfo.ecomSubId,
                billing_type: paymentIntentInfo.billingType,
                email: formData.contactEmail,
                province: formData.state,
                stripe_subscription_id: paymentIntentInfo.subscriptionId,
                customer_id: paymentIntentInfo.customerId,
                customer_data: {
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    phone: formData.phoneNumber
                },
                is_final: true
            }
            if (type === 'coaching') {
                payload.product_id = paymentIntentInfo.ecomSubId
            }
            if (isLoggedIn) {
                payload.token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            }
            let url = `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PI}`
            if (type === 'coaching') {
                url = `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.PROVIDER_CHECKOUT}`
            }
            // alert(url)
            await axios({
                method: 'POST',
                headers: { 'Content-Type': "application/json" },
                url,
                data: payload
            })
            .then(async (response) => {
                console.log(response.data)
                const responseData = response.data;
                if (responseData.status) {
                    const checkoutData = responseData.data;
                    if (checkoutData.stripe_data.payment_intent_client_secret) {
                        await stripePayment(checkoutData, formData, isLoggedIn, type)
                    }
                } else {
                    setErrorMsg('Error, please try again later.')
                    setPaymentInProcess(false)
                }
            })
            .catch((error) => {
                console.log(error)
                setErrorMsg('Error, please try again later.')
                setPaymentInProcess(false)
            })
        } else {
            const result = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: `${formData.firstName} ${formData.lastName}`,
                    email: formData.contactEmail,
                    phone: formData.phoneNumber,
                    address: {
                        line1: formData.addressLine1,
                        line2: formData.addressLine2,
                        city: formData.city,
                        state: formData.state,
                        postal_code: formData.postalCode,
                        country: formData.country,
                    },
                }
            })
            if (result.error) {
                if (type === 'subscription') {
                    let checkoutData = {
                        id: paymentIntentInfo.ecomSubId,
                        billing_type: paymentIntentInfo.billingType,
                        paymentMethodId: "",
                        stripe_data: {
                            stripe_subscription_id: paymentIntentInfo.subscriptionId,
                            customer_id: paymentIntentInfo.customerId,
                            payment_intent_id: paymentIntentInfo.paymentIntentId,
                        }
                    }
                    sendSubscriptionPaymentResponseToBackend(formData, checkoutData, 'failed', result?.error?.message, 'subscription')
                }
                setErrorMsg(result?.error?.message);
                setPaymentInProcess(false);
            } else {
                console.log('CHECK SUCCESS') 
                if (result.paymentMethod.id) {
                    console.log('CHECK is success')
                    window.scrollTo(0, 0)
                    if (type === 'subscription') {
                        let payload = {
                            subscription_id: paymentIntentInfo.ecomSubId,
                            billing_type: paymentIntentInfo.billingType,
                            email: formData.contactEmail,
                            province: formData.state,
                            stripe_subscription_id: paymentIntentInfo.subscriptionId,
                            customer_id: paymentIntentInfo.customerId,
                            customer_data: {
                                first_name: formData.firstName,
                                last_name: formData.lastName,
                                phone: formData.phoneNumber
                            },
                            is_final: true
                        }
                        if (isLoggedIn) {
                            payload.token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                        }
                        await axios({
                            method: 'POST',
                            url: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PI}`,
                            headers: { 'Content-Type': "application/json" },
                            data: payload
                        })
                        .then(async (response) => {
                            console.log(response.data)
                            const responseData = response.data;
                            if (responseData.status) {
                                let checkoutData = responseData.data;
                                checkoutData.paymentMethodId = result.paymentMethod.id
                                sendSubscriptionPaymentResponseToBackend(formData, checkoutData, 'success', "", type)
                            } else {
                                setErrorMsg('Error, please try again later.')
                                setPaymentInProcess(false)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            setErrorMsg('Error, please try again later.')
                            setPaymentInProcess(false)
                        })
                    }
                }
            }
        }
    }

    const stripePayment = async (checkoutData, formData, isLoggedIn, type) => {
        setErrorMsg('')
        setCardNumberError('')
        setCardCVVError('')
        setCardExpError('')
        console.log('Calling Stripe Payment')
        console.log(CardNumberElement)
        const piClientSecret = checkoutData.stripe_data?.payment_intent_client_secret
        const result = await stripe.confirmCardPayment(
            piClientSecret,
            {
                payment_method: {
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        name: `${formData.firstName} ${formData.lastName}`,
                        email: formData.contactEmail,
                        phone: formData.phoneNumber,
                        address: {
                            line1: formData.addressLine1,
                            line2: formData.addressLine2,
                            city: formData.city,
                            state: formData.state,
                            postal_code: formData.postalCode,
                            country: formData.country,
                        },
                    }
                },
                return_url: `${CONFIG.STRIPE_RETURN_URL}/orders`,
            },
            {
                handleActions: true
            }
        )
        console.log(result)
        // setPaymentInProcess(false);
        // return;
        if (result.error) {
            if (result.error.code && result.error.type === 'validation_error') {
                if (result.error.code.includes('expiry')) {
                    setCardExpError(result.error.message)
                } else if (result.error.code.includes('cvc')) {
                    setCardCVVError(result.error.message)
                } else if (result.error.code.includes('number')) {
                    setCardNumberError(result.error.message)
                }
                setPaymentInProcess(false);
            } else if (type === 'subscription' || type === 'coaching') {
                sendSubscriptionPaymentResponseToBackend(formData, checkoutData, 'failed', result?.error?.message, type)
            } else if (type === 'product') {
                sendProductPaymentResponseToBackend(formData, checkoutData, 'failed', result?.error?.message)
            }
            setErrorMsg(result?.error?.message);
            setPaymentInProcess(false);
        } else {
            console.log('CHECK SUCCESS') 
            if (result.paymentIntent.status === 'succeeded') {
                console.log('CHECK is success')
                window.scrollTo(0, 0)
                if (type === 'subscription' || type === 'coaching') {
                    sendSubscriptionPaymentResponseToBackend(formData, checkoutData, 'success', '', type)
                } else if (type === 'product') {
                    sendProductPaymentResponseToBackend(formData, checkoutData, 'success')
                }
            }
        }
    }

    const sendSubscriptionPaymentResponseToBackend = (formData, checkoutData, payment_status, payment_message, type) => {
        console.log('Send data to backend', formData, checkoutData, payment_status, payment_message, type)
        if (!_.isEmpty(formData)) {
            let payload = {
                // subscription_id: checkoutData.id,
                // billing_type: checkoutData.billing_type,
                email: formData.contactEmail,
                stripe_subscription_id: checkoutData.stripe_data.subscription_id,
                customer_id: checkoutData.stripe_data.stripe_customer_id,
                payment_intent_id: checkoutData.stripe_data.payment_intent_id,
                payment_method_id: checkoutData.paymentMethodId,
                billing_address: formData,
                payment_status,
                payment_message,
            }
            if (isLoggedIn) {
                payload.token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            }
            if (type === 'subscription') {
                payload.subscription_id = checkoutData.id
                payload.billing_type = checkoutData.billing_type
                dispatch(paymentUpdateMembershipPage({
                    URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.MEMBERSHIP_PAYMENT_UPDATE}`,
                    isJSON: true,
                    method: 'post',
                    payload
                }))
            } else if (type === 'coaching') {
                payload.product_id = checkoutData.product_id
                if (checkoutData.payment_frequency === 'onetime') payload.stripe_subscription_id = checkoutData.stripe_data.invoice_id
                // alert(JSON.stringify(payload));
                dispatch(getProviderPlaceOrderV2({
                    URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.PROVIDER_PLACEORDER}`,
                    isJSON: true,
                    method: 'post',
                    payload
                }))
            }
        }
    }

    const sendProductPaymentResponseToBackend = (formData, checkoutData, payment_status, payment_message = "") => {
        if (!_.isEmpty(formData)) {
            let payload = {
                first_name: formData.firstName,
                last_name: formData.lastName,
                address_1: formData.addressLine1,
                address_2: formData.addressLine2,
                city: formData.city,
                state: formData.state,
                postcode: formData.zip,
                country: formData.country,
                company: "",
                phone: formData.phoneNumber,
                brokerage_email: formData.brokerage_email ? formData.brokerage_email : "",
                order_status: payment_status,
                email: isMobile ? authIframeBroker.payload.user.email : isLoggedIn ? authBroker.payload.user.email : formData.contactEmail,
                token: formData.paymentIntentsToken,
                tnc_checked: true,
                tnc_time: moment().unix(),
                user_token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN): localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                session_id: localStorage.getItem(SessionKeys.SESSION_ID),
                product_id: paymentIntentInfo.productId,
                direct_order: formData.directOrder,
                coupon_code: isCouponApplied ? couponCode : "",
                apply_redeem: shouldRedeem,
                payment_message
            }

            dispatch(
                sendOrderPlace({
                    module: "sendOrderResponse",
                    postData: payload
                })
            )
        }
    }

    return (
        <>
            {
            paymentIntentInfo.total ?
            <>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <div className="input-text ">
                                <label
                                    htmlFor="cardNumber"
                                    className="input__label"
                                >
                                    Card Number<span>*</span>
                                </label>
                                <div className="card-input-element input__field">
                                    <CardNumberElement disabled={!enableFormField} />
                                </div>
                                <span className="error-message">{cardNumberError}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <div className="input-text ">
                                <label
                                    htmlFor="cardCVC"
                                    className="input__label"
                                >
                                    CVC<span>*</span>
                                </label>
                                <div className="card-input-element input__field">
                                    <CardCvcElement disabled={!enableFormField} />
                                </div>
                                <span className="error-message">{cardCVVError}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <div className="input-text ">
                                <label
                                    htmlFor="cardExpiry"
                                    className="input__label"
                                >
                                    Expiration Month / Year<span>*</span>
                                </label>
                                <div className="card-input-element input__field">
                                    <CardExpiryElement disabled={!enableFormField} />
                                </div>
                                <span className="error-message">{cardExpError}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            : ""
            }
        </>
    )
})

export default StripePaymentPanel